const baseUrl = "Session";

export const getSessionsUrl = () => `${baseUrl}/user-sessions`;
export const getAllSessionsUrl = () => `${baseUrl}/all-sessions`;
export const getAllSessionsPerInvoiceTypeUrl = (typeId) => `${baseUrl}/${typeId?.invoiceType}/application-sessions`;

